import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetAlloysPartnersShopifyFetchMarketsResult = objectOf({
  markets: arrayOf(
    objectOf({
      id: string,
      name: string,
      handle: string,
      countries: arrayOf(
        objectOf({
          code: string,
          name: string,
        })
      ),
    })
  ),
});
